<template>
  <div class="page">
    <div class="page-content">
      <div class="layoutTop" />
      <b-container fluid>

        <b-row>
          <b-col md="10" offset-md="1">
            <f7-list v-if="this.capsule === 'draft-edit'" class="draftTitle">
              <f7-list-item>
                <f7-label class="paymentsRequestSubOption formLabel formLabelPayment">
                  <span class="color-red">*</span>
                  Draft name
                </f7-label>
                <f7-input class="paymentsRequestSubOption" placeholder="Draft name" type="text" v-model="draftName">
                </f7-input>
              </f7-list-item>
            </f7-list>
          </b-col>
        </b-row>


        <!-- ====================================== -->
        <!--                  FORM                  -->
        <!-- ====================================== -->
        <b-row>
          <b-col md="10" offset-md="1">
            <back-button returnUrl="/home/"></back-button>
            <div class="panel21 panel-default">

              <div class="panel-heading">
                <div class="showLargeScreenOnly formTitleBlock">
                  <h4 class="content-block labelAccordionForm" :style="{color: titleColor}">
                    <img src='../../../assets/static/images/icons/inbox_out.png' class="formIcon" />
                    {{ $t('modularLoan.new_ml_rqst') }}
                  </h4>
                </div>
                <div class="showSmallScreenOnly formTitleBlock">
                  <h6 class="content-block labelAccordionForm creationFormTitle" :style="{color: titleColor}">
                    <img src='../../../assets/static/images/icons/inbox_out.png' class="formIcon" />
                    {{ $t('modularLoan.new_ml_rqst') }}
                  </h6>
                </div>
                <div class="content-block italicMandatoryIndication">
                  {{ $t('common.asterisk_obligation_label')}}
                </div>
              </div>
              <!-- ====================================== -->
              <!--              ATTACHMENTS               -->
              <!-- ====================================== -->
              <b-row>
                <b-col md="6">
                  <form-accordion :title="$t('attachments.doc')" :open="false">
                    <!-- <b-form-group>
                      <b-form-radio class="creationFormBtnRadio" v-model="typeFile" name="transferType" value="1">{{ $t('common.import_device') }}</b-form-radio>&nbsp;&nbsp;
                      <b-form-radio class="creationFormBtnRadio" v-model="typeFile" name="transferType" value="2">{{ $t('creation_forms.imprt_frm_moneyroad') }}</b-form-radio>
                    </b-form-group> -->

                  <div class="form-group row justify-content-start">
                    <b-col v-if="!demo">
                      <b-form-group>
                        <b-form-radio-group
                          :disabled="this.readonly"
                          v-model="fileIsFacturX"
                          :options="fileTypeSelect">
                        </b-form-radio-group>
                      </b-form-group>
                    </b-col>
                    <div class="col-12" v-if="!readonly && typeFile === '1' && !attachement">
                      <f7-button round
                        class="attachmentButton buttonAccordionForm longword-word generalBottomButton"
                        @click="openImportAttachment(typeFile)">
                        {{ fileIsFacturX ? 'Importer une Factur-X' : $t('attachments.import_doc') }}
                      </f7-button>
                    </div>
                    <div class="col-12 scanbutton"
                      v-if="!readonly && isSmartphoneOS && hasCamera">
                      <f7-button round
                        class="attachmentButton buttonAccordionForm generalBottomButton"
                        @click="scanOrder($event)">
                        {{ $t('creation_forms.scn_ordr_form') }}
                      </f7-button>
                    </div>
                  </div>
                  <b-row>
                    <b-col>
                      <input v-if="typeFile === '1' && attachementNameLabel === $t('creation_forms.imprt_file')"
                        class="form-control inputAccordionForm"
                        type="text"
                        :placeholder="$t('creation_forms.slct_a_fl')"
                        readonly
                        v-model="attachementNameLabel" id="application-file-input"
                        :disabled="this.readonly">
                      </input>
                      <div class="d-flex justify-content-between">
                        <label v-if="typeFile === '1' && attachementNameLabel !== $t('creation_forms.imprt_file')"
                          id="application-file-input"
                          v-model="attachementNameLabel">{{attachementNameLabel}}
                        </label>
                        <div class="d-flex">
                          <i v-if="typeFile === '1' && attachementNameLabel !== $t('creation_forms.imprt_file')" class="icon fa fa-download mx-1" @click="view(attachmentId)"/>
                          <i v-if="typeFile === '1' && attachementNameLabel !== $t('creation_forms.imprt_file')" class="icon fa fa-search mx-1" @click="openDoc(attachmentId)"/>
                        </div>
                      </div>
                      <select class="form-control" id="sel2" readonly v-model="attachmentId"
                        v-if="typeFile === '2'" @change="cloudFileSel()">
                        <option value="" default disabled>
                          {{ this.hasCloudAttachments ? $t('creation_forms.slct_a_fl') : $t('attachments.no_document') }}
                        </option>
                        <option v-for="cloudDoc in cloudDocsPicker" :key="cloudDoc.id" :value="cloudDoc.id"> {{ cloudDoc.name }}</option>
                      </select>
                      <input class="item-input hiddenElementAllSize local-file-input" @change="onFileChange" type="file" accept=".pdf" :key="refreshImport"/>
                      <input class="hiddenElementAllSize" type="text"></input>
                      <input class="hiddenElementAllSize" type="text" id="recommendation-list-input"></input>
                    </b-col>
                  </b-row>
                  <b-row v-if="(typeof attachmentName) !== 'undefined' && attachmentName !== ''">
                    <b-col>
                      <form-write-group-label-input v-model="attachmentReference"
                        :inputLabel="$t('common.rfrnc')" :placeholderValue="$t('common.rfrnc_desc')"
                        :disabled="this.readonly">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row v-if="!readonly" class="form-group justify-content-right">
                    <b-col v-if="isSmartphone" md="4" offset-md="2">
                      <f7-button round
                        class="buttonAccordionForm attachmentButton generalBottomButton"
                        v-if="hasAttachment"
                        @click="view(attachmentId)">
                        {{ $t('creation_forms.view_attchmnt') }}
                      </f7-button>
                    </b-col>
                    <!-- <div v-if="!isSmartphone" class="col-md-6" :class="colorBottomButton"> -->
                      <!-- <f7-button round v-if="hasAttachment" class="attachmentButton" @click="view(attachmentId)">{{ $t('creation_forms.dwnld_attchmnt') }}</f7-button> --> <!--Download-->
                    <!-- </div> -->
                    <b-col md="4">
                      <f7-button round
                        class="attachmentButton generalBottomButton"
                        v-if="(typeof attachmentName) !== 'undefined' && attachmentName !== ''"
                        @click="clearAttachement()">
                        {{ $t('creation_forms.clear_label') }}
                      </f7-button>
                    </b-col>
                  </b-row>
                  <div v-if="readonly && hasAttachment" class="row">
                    <div v-if="isSmartphone" class="col-md-4 offset-md2">
                      <f7-button round
                        class="buttonAccordionForm attachmentButton"
                        @click="view(attachmentId)">
                        {{ $t('creation_forms.view_attchmnt') }}
                      </f7-button>
                    </div>
                    <div v-if="!isSmartphone" class="col-md-4 offset-md2">
                      <f7-button round class="buttonAccordionForm attachmentButton"
                        style="width:200px;"
                        @click="view(attachmentId)">
                        {{ $t('creation_forms.dwnld_attchmnt') }}
                      </f7-button> <!--Download-->
                    </div>
                  </div>
                </form-accordion>
              </b-col>
            </b-row>
            <hr>

              <!-- ====================================== -->
              <!--           DEBTOR INFORMATION           -->
              <!-- ====================================== -->
              <form-accordion :title="$t('common.formsSubTitle.item_info_DD')">
                <!-- <div class="form-group">
                  <div class="row justify-content-start">
                    <div class="col-md-6 col-8" :class="{blueBottomButton: isOcrActive, greyBottomButton: !isOcrActive}">
                      <input class="item-input hiddenElementAllSize rib-file-input"
                        @change="executeOCROnRIB" type="file">
                      </input>
                      <f7-button round
                        class="attachmentButton buttonAccordionForm"
                        @click="importRIB($event)"
                        :disabled="!isOcrActive">
                        {{ $t('sent.import_RIB_btn') }}
                      </f7-button>
                    </div>
                  </div>
                </div> -->
                  <b-row>
                    <b-col sm="6" class="form-group">
                      <form-contact-dropdown-label-input v-model="beneficiaire" isMandatory
                        :inputLabel="$t('common.nme')"
                        :placeholderValue="$t('common.debtor_name')"
                        :disabled="readonly"
                        :mandatoryErrorIndicator="beneficiaireError"
                        @change-iban="recipientBankAccount = $event"
                        @change-identifier="recipientEmail = $event"
                        @change-zonecode="handleChangeRecipientZoneCode($event)">
                      </form-contact-dropdown-label-input>
                    </b-col>
                    <b-col sm="6" class="form-group">
                      <form-write-group-label-input v-model="recipientEmail" isMandatory
                        :disabled="readonly"
                        :inputLabel="$t('common.idtfr')"
                        :placeholderValue="$t('creation_forms.debtor_email_siren')"
                        :regexpErrorIndicator="recipientEmailRegexpError">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>

                  <b-row>
                    <div class="form-group col-sm-6">
                      <label>
                        {{ $t('common.account_zone') }}
                        <span class="color-red">* </span>
                      </label>
                      <select class="form-control" id="sel4" v-model="recipientZoneCode" :disabled="readonly">
                        <option v-for="country in countries" :key="country.id"
                         :value="country"
                         :disabled="country.disabled || (!canSelectOtherThanEuro && country.label !== 'EUR')"
                         :selected="country.selected">
                         {{ $t('zoneCodes.' + country.label) }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="form-group col-sm-6"
                      v-for="accountLabel in recipientZoneCode.accountLabel"
                      :key="accountLabel">
                      <label>
                        {{ $t('bank_accounts.bank_account_singular') }} <span class="color-red">* </span>
                      </label>
                      <input
                        :disabled="readonly"
                        name="identifier"
                        class="form-control"
                        :class="{'errorBorder': recipientZoneCode.errors[accountLabel] === 'missing' ||
                                                recipientZoneCode.errors[accountLabel] === 'incorrect'}"
                        type="text"
                        :placeholder="$t('common.debtor_ibn')"
                        v-model="recipientZoneCode.values[accountLabel]">
                      </input>
                      <div v-if="recipientZoneCode.errors[accountLabel] === 'missing'" style="color:red;">
                        {{ $t('errors.is_mandatory', {mandatoryValue : $t(accountLabel) }) }}
                      </div>
                      <div v-else-if="recipientZoneCode.errors[accountLabel] === 'incorrect'" style="color:red;">
                        {{ $t('errors.is_incorrect', {incorrectValue : $t(accountLabel) }) }}
                      </div>
                    </div>
                  </b-row>
                </form-accordion>
                <hr>

              <!-- ====================================== -->
              <!--       MY ACCOUNT INFORMATION           -->
              <!-- ====================================== -->
                <b-row class="showLargeScreenOnly">
                  <b-col md="6" class="form-group">
                    <select-bank-account v-model="creditorBank">
                    </select-bank-account>
                  </b-col>
                </b-row>

              <hr />

              <!-- ====================================== -->
              <!--      MODULAR LOANS INFORMATION         -->
              <!-- ====================================== -->
              <form-accordion :title="$t('common.formsSubTitle.mod_loan_dtls')">
                <b-row>
                  <b-col sm="6" class="form-group">
                    <form-write-group-label-input v-model="remittanceInformation" isMandatory
                      :inputLabel="$t('common.rsn')"
                      :placeholderValue="$t('common.rsn')">
                    </form-write-group-label-input>
                  </b-col>
                  <b-col sm="6" class="form-group">
                    <form-write-group-label-input v-model="amount" isMandatory
                      inputType="number"
                      :inputLabel="$t('common.amnt')"
                      :placeholderValue="$t('common.amnt')">
                    </form-write-group-label-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="6" class="form-group">
                    <form-write-group-label-input v-model="depositExecutionDate" isMandatory
                      inputType="date" disablePastDates
                      :inputLabel="$t('common.date_label')"
                      :placeholderValue="$t('common.slct_date')">
                    </form-write-group-label-input>
                  </b-col>
                  <b-col sm="6" class="form-group">
                    <form-write-group-label-input v-model="deposit" isMandatory
                      inputType="number"
                      :inputLabel="$t('common.deposit_amnt_label')"
                      :placeholderValue="$t('common.deposit_amnt_label')">
                    </form-write-group-label-input>
                  </b-col>
                </b-row>
              </form-accordion>

              <!-- ====================================== -->
              <!--          INSTALLMENT RULES             -->
              <!-- ====================================== -->
              <hr v-if="rulesEnabled" />
              <form-accordion :title="$t('regles_metier.titles.rules')" v-if="rulesEnabled">
                <b-row>
                  <b-col sm="6">
                    <b-form-group>
                      <b-form-checkbox v-model="hasRegles"
                        :disabled="!canAddInstallmentRules"
                        :value="true" :unchecked-value="false"
                        @change="getAllInstallmentRules()">
                        {{ $t('regles_metier.add_installment_rules') }}
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group>
                      <b-form-checkbox v-model="negotiationAllowed"
                        :disabled="!canAddInstallmentRules"
                        :value="true" :unchecked-value="false">
                        {{ $t('regles_metier.allow_edit_installments_rules') }}
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="6">
                    <div class="form-group" v-show="hasRegles">
                      <label>{{ $t('regles_metier.select_installment_template') }}</label>
                      <select class="form-control" @change="setInstallmentRules($event)">
                        <option selected :value="0">{{ $t('regles_metier.none_installment_template') }}</option>
                        <!-- <option :value="0">Manual</option> -->
                        <option v-for="rule in allRules" :value="rule.idReglesMetier" :key="rule.idReglesMetier">
                          {{`${rule.nom} – [installments: ${rule.nbEcheances.min} - ${rule.nbEcheances.max}]`}}
                        </option>
                      </select>
                    </div>
                  </b-col>
                </b-row>
                <regles-form hideInfo hideInterests
                  v-if="hasRegles" :value="reglesMetier"
                  @input="reglesMetier = $event"
                  @echeance-changed="echeanceChanged($event)">
                </regles-form>
              </form-accordion>

              <hr v-if="rulesEnabled && reglesMetier.idReglesMetier && hasRegles" />
              <form-accordion :title="$t('regles_metier.titles.rules_details')"
                v-if="rulesEnabled && reglesMetier.idReglesMetier && hasRegles">
                <regles-details v-if="reglesMetier.idReglesMetier && hasRegles"
                  :reglesMetier="reglesMetier">
                </regles-details>
                <p v-else>{{ $t('regles_metier.details.no_rules') }}</p>
              </form-accordion>

              <hr>

              <!-- ====================================== -->
              <!--             INSTALLMENTS               -->
              <!-- ====================================== -->
              <form-accordion :title="$t('regles_metier.titles.installments')">
                <b-row>
                  <b-col sm="6" class="form-group">
                    <b-form-checkbox v-model="hasInstallments"
                      :value="true" :unchecked-value="false"
                      :disabled="reglesMetier.nbEcheances.min > reglesMetier.nbEcheances.max">
                      {{ $t('regles_metier.add_installments') }}
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="6" class="form-group">
                    <b-form-checkbox v-model="modificationInstallmentsAllowed"
                      :value="true" :unchecked-value="false">
                      {{ $t('regles_metier.edit_installments') }}
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="6" class="form-group" v-if="hasInstallments">
                    <label>
                      {{ $t('regles_metier.select_nb_installments') }}
                    </label>
                    <select v-if="hasRegles && reglesMetier.idReglesMetier" :disabled="!hasInstallments"
                      class="form-control" v-model="payNumber">
                      <option
                        v-for="nb in $R.range(parseInt(reglesMetier.nbEcheances.min), parseInt(reglesMetier.nbEcheances.max)+1)"
                        :value="nb">
                        {{nb}}
                      </option>
                    </select>
                    <b-form-input v-else v-model="payNumber"
                      type="number" min="1" max="24"
                      :disabled="!hasInstallments">
                    </b-form-input>
                  </b-col>
                </b-row>
                <echeancier v-if="hasInstallments" :numPay="payNumber" :min="borneInf" :amount="amount" :ccy="ccy"
                  :deposit="deposit" v-model="multPmts" />
              </form-accordion>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-start">
          <b-col md="3" offset-md="1">
            <!-- Bouton "Save request" disabled pour GCollect -->
            <!-- <button round
            v-bind:class="savePosition"
            class="button-action firstButtonMarginTop"
              @click="getNameDraft">
              <i class="icon fa fa-save"></i>
              Save Request
            </button> -->
          </b-col>
          <b-col md="3" offset-md="4">
            <f7-button class="button-action milkyBlockBlack" @click="sendDirectDebit">
              <f7-icon fa="paper-plane"></f7-icon>
              {{ $t('creation_forms.snd_rqust') }}
            </f7-button>
          </b-col>
        </b-row>
      </b-container>

      <div class="toolbarPageBottomBlank"></div>

    </div>
  </div>
</template>

<script>
import b64toBlob from 'b64-to-blob'
import moment from 'moment'

import backButton from '@/components/common/backButton.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formContactDropdownLabelInput from '@/components/common/formContactDropdownLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import selectBankAccount from '@/pages/requests/components/selectBankAccount.vue'

import Echeancier from '@/pages/requests/EcheancierForm.vue'
import ReglesDetails from '@/pages/reglesEcheancier/EcheancierReglesDetails.vue'
import ReglesForm from '@/pages/reglesEcheancier/EcheancierReglesForm.vue'

import datePickerMixin from '@/mixins/datePickerMixin'
import {extractForeignIban} from '@/helpers/format'
import {errorMessageAlert} from '@/helpers/alert'
// import {get} from '@/helpers/api'
// import {getPayments} from '@/helpers/payments'
import {loadPage} from '@/helpers/routing'
// import PaymentsSentboxPage from '@/pages/services/payments/CMSendboxPage.vue'
import {validateIBAN} from '@/helpers/validator'

export default {
  mixins: [datePickerMixin],
  name: 'writePayments',
  props: ['capsule', 'saveMessage', 'subNavTitle'],
  components: {
    'back-button': backButton,
    'bottom-toolbar': bottomToolbar,
    'echeancier': Echeancier,
    'form-accordion': FormAccordion,
    'form-contact-dropdown-label-input': formContactDropdownLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'regles-details': ReglesDetails,
    'regles-form': ReglesForm,
    'select-bank-account': selectBankAccount
  },
  data () {
    return {
      accountsPicker: '',
      accountType: '',
      allRules: [],
      amount: '',
      attachement: '',
      attachementId: '',
      attachmentId: '',
      attachmentName: '',
      attachementReference: '',
      attachmentReference: '',
      bankAccounts: [],
      beneficiaire: '',
      beneficiaireError: false,
      canAddInstallmentRules: false,
      canSelectOtherThanEuro: false,
      canSendAttachment: false,
      ccy: '€',
      cloudDocsPicker: '',
      cloudFiles: [],
      // colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      contacts: [],
      contactsObject: {},
      contactsPicker: '',
      contactSelectionList: [],
      countries: '',
      countryPicker: '',
      creditorBank: '',
      creditorBankName: '',
      debtorBank: '',
      debtorEmail: '',
      debtorName: '',
      demo: true,
      deposit: '',
      depositExecutionDate: '',
      directPayments: '0',
      draftName: '',
      enteredDebtors: [],
      fileIsFacturX: false,
      fileTypeSelect: [{ text: this.$i18n.t('common.classic_invce_radio'), value: false }, { text: this.$i18n.t('common.facturx_radio'), value: true }],
      fromCloud: false,
      hasAttachment: false,
      hasCloudAttachments: false,
      hasInstallments: false,
      hasRegles: false,
      idDraft: '',
      ImmPmtAccepted: false,
      isComplete: '0',
      isOcrActive: false,
      isSmartphone: false,
      isSmartphoneOS: false,
      isValidated: '0',
      loadingFile: false,
      modificationAccepted: false,
      modificationInstallmentsAllowed: this.$engine.settings.directDebit.get().defaultModificationInstallmentsAllowed === '1',
      multPmts: [],
      negotiationAllowed: this.$engine.settings.directDebit.get().defaultNegotiationAllowed === '1',
      payNumber: 1,
      recipientBankAccount: '',
      recipientEmail: '',
      recipientEmailError: false,
      recipientEmailRegexpError: false,
      recipientZoneCode: {
        id: 0,
        label: 'slct_zone',
        disabled: true,
        selected: true
      },
      recipientZoneCodeError: false,
      refreshImport: false,
      reglesMetier: this.$engine.reglesMetier.defaultData(),
      remittanceInformation: '',
      selected: '',
      selectedContact: {},
      selectedDebtor: {},
      sendPaymentsClicked: false,
      sumColor: 'red',
      titleColor: this.$engine.services.getServiceColor(this.$engine.user.currentService.id),
      typeFile: '1'
    }
  },
  computed: {
    amountColor () {
      return this.amount === '' && this.sendPaymentsClicked
    },
    attachementNameLabel () {
      if (this.attachmentName === '' && this.isSmartphone) {
        return this.$i18n.t('creation_forms.imprt_or_scn_file')
      } else if (this.attachmentName === '') {
        return this.$i18n.t('creation_forms.imprt_file')
      } else if (this.attahmentName === '' && this.readonly) {
        return this.$t('common.no_doc')
      } else {
        return this.attachmentName
      }
    },
    borneInf () {
      if (this.hasRegles) {
        return this.reglesMetier.nbEcheances.min
      } else {
        return 1
      }
    },
    creditorColor () {
      return this.creditorBankName === '' && this.sendPaymentsClicked
    },
    debtorListColor () {
      // return Object.keys(this.selectedDebtors).length === 0 && this.enteredDebtors.length === 0 && this.sendPaymentsClicked
      return this.selected === '' && this.sendPaymentsClicked
    },
    depositExecutionDateColor () {
      return (this.depositExecutionDate === '' || this.depositExecutionDate === 'Invalid date') && this.sendPaymentsClicked
    },
    hasCamera () {
      return navigator.camera !== undefined
    },
    readonly () {
      return this.accountType === '1' && this.isComplete === '1' && (this.isValidated === '1' || this.isValidated === '2')
    },
    remittanceInformationColor () {
      return this.remittanceInformation === '' && this.sendPaymentsClicked
    },
    rulesEnabled () {
      return this.$engine.settings.directDebit.get().enableInstallmentRules === '1'
    },
    savePosition: function () {
      return {
        leftfav: true
      }
    },
    sum: function () {
      let sum = 0
      for (let i = 0; i < this.multPmts.length; i++) {
        sum += (this.multPmts[i].amount === '' || this.multPmts[i].amount == null) ? 0 : parseFloat(this.multPmts[i].amount)
      }
      sum += (this.deposit == null || this.deposit === '') ? 0 : parseFloat(this.deposit) // On ajoute le deposit, correspondant a l'echeance 0
      return sum
    }
  },
  mounted () {
    this.$engine.services.payments.contactDebtorList = []

    // Guangze: get default modificationAccepted value
    this.modificationAccepted = this.$engine.settings.directDebit.get().defaultNegotiationAllowed === '1'
    if (this.modificationAccepted) {
      this.Dom7('.checkboxModificationAccepted').prop('checked', true)
    }
    /* IRY 04/2020 Par défaut le compte recipient est 'EU' */
    this.recipientZoneCode = this.$engine.bankAccounts.getZoneData('EUR')
    this.recipientZoneCode.values = {}
    if (this.recipientBankAccount) {
      this.handleChangeRecipientZoneCode('EUR')
    }
  },
  created () {
    let that = this
    this.canSelectOtherThanEuro = this.$engine.rights.rightIs('dp_request_other_euro', true)
    this.canSendAttachment = this.$engine.rights.rightIs('ml_request_add_attachment', true)
    this.canAddInstallmentRules = this.$engine.rights.rightIs('ml_request_rules', true)
    if (that.$engine.services.directDebit.filter.smartphoneStorage) {
      that.isSmartphone = true
    }
    that.countries = this.$engine.bankAccounts.getZoneCode()
    if (that.$engine.services.directPayments.filter.smartphoneStorage) {
      that.isSmartphone = true
    }
    if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
      this.isSmartphone = true
    }

    if (this.$engine.settings.directDebit.get().ocrActivation === '1') {
      that.isOcrActive = true
    }
    that.multPmts = []
    // that.multPmts.push({date: that.$settings.clickedMessage.reqstdExecDt, amount: that.$settings.clickedMessage.amt})
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$on('refresh-contact-payments', (data) => {
      this.debtorName = data.debtorName
      this.debtorBank = data.debtorBank
      this.debtorEmail = data.debtorEmail
    })
    this.enteredDebtors = this.$engine.services.payments.debtorList
    // TODO : selected
    // this.selected = this.$engine.services.payments.contactDebtorList
    this.selected = ''
    this.$engine.services.payments.contactDebtorList = []
    this.$engine.services.payments.contactGroupsSelected = []
    // this.contacts = this.$settings.currentAccount.contacts
    this.contacts = this.$engine.contacts.get()
    for (var i = 0; i < that.contacts.length; i++) {
      that.contactsObject[that.contacts[i].id] = that.contacts[i]
    }
    this.setContacts()
    this.$bus.$on('refresh-debtor-contact-list', (data) => {
      that.selected = data
      that.selectedDebtor = {}
      that.selectedDebtor = that.contactsObject[this.selected]

      that.debtorName = that.selectedDebtor.name
      that.debtorEmail = that.selectedDebtor.identifier
      that.debtorBank = that.selectedDebtor.iban
    })
    this.bankAccounts = this.$engine.bankAccounts.get()
    this.cloudFiles = this.$engine.attachments.get()

    let params = {
      idAcct: this.$engine.user.get().id
    }
    that.$engine.attachments.getRefresh(params).then(response => {
      this.cloudFiles = response.data.docs
      let filesMap = this.cloudFiles.map(function (obj) {
        let rObj = {}
        rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
        return rObj
      })
      let filesMapObj = Object.assign({}, ...filesMap)

      if (Object.keys(filesMapObj).length > 0) {
        this.hasCloudAttachments = true
      }
      this.cloudDocsPicker = filesMapObj
    })
    .catch(err => {
      errorMessageAlert(err, that)
    })
    this.loadingFile = false
    this.fromCloud = false
    this.depositExecutionDate = moment().format('YYYY-MM-DD')
    this.creditorBank = ''
    this.creditorBankName = ''
    that.attahmentName = 'File'
    if (typeof (this.$settings.preChargedFile) !== 'undefined') {
      if (this.$settings.preChargedFile.fromCloudList === true) {
        this.fromCloud = true
        this.attachementId = this.$settings.preChargedFile.id
        this.attachmentName = this.$settings.preChargedFile.name
        this.attachement = this.$settings.preChargedFile.data
        this.attachementReference = this.$settings.preChargedFile.reference
        this.amount = this.$settings.preChargedFile.amount
        this.depositExecutionDate = this.$settings.preChargedFile.depositExecutionDate
        this.debtorName = this.$settings.preChargedFile.debtorName
        this.debtorEmail = this.$settings.preChargedFile.debtorEmail
        this.debtorBank = this.$settings.preChargedFile.debtorBankAccount
        this.remittanceInformation = this.$settings.preChargedFile.remittanceInformation
        if (this.debtorName !== '' && this.debtorEmail === '') {
          for (i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].name === this.$settings.preChargedFile.debtorName) {
              that.debtorName = this.contacts[i].name
              that.debtorBank = this.contacts[i].iban
              that.debtorEmail = this.contacts[i].identifier
            }
          }
        }
      }
    }
    this.$settings.preChargedFile = undefined
    if (typeof (this.$settings.preChargedDraft) !== 'undefined') {
      if (this.$settings.preChargedDraft.AttachmentId !== '') {
        this.attachementId = this.$settings.preChargedDraft.AttachmentId
      }
      if (this.$settings.preChargedDraft.attachmentName !== '') {
        this.attachmentName = this.$settings.preChargedDraft.attachmentName
      }
      if (this.$settings.preChargedDraft.Attachment !== '' && this.$settings.preChargedDraft.Attachment !== '$NotFound') {
        this.attachement = this.$settings.preChargedDraft.Attachment
      }
      if (this.$settings.preChargedDraft.AttachmentReference !== '') {
        this.attachementReference = this.$settings.preChargedDraft.AttachmentReference
      }
      if (this.$settings.preChargedDraft.CreditorBankAccount !== '') {
        this.creditorBank = this.$settings.preChargedDraft.CreditorBankAccount
      }
      if (this.$settings.preChargedDraft.RemittanceInformation !== '') {
        this.remittanceInformation = this.$settings.preChargedDraft.RemittanceInformation
      }
      if (this.$settings.preChargedDraft.RequestedExecutionDate !== '') { // DEPOSIT exec date
        this.depositExecutionDate = this.$settings.preChargedDraft.RequestedExecutionDate
      }
      if (this.$settings.preChargedDraft.Amount !== '') {
        this.amount = this.$settings.preChargedDraft.Amount
      }
      if (this.$settings.preChargedDraft.Deposit !== '' && this.$settings.preChargedDraft.Deposit != null) {
        this.deposit = this.$settings.preChargedDraft.Deposit
      }
      if (this.$settings.preChargedDraft.ModificationAccepted === 'true') {
        this.modificationAccepted = true
      } else if (this.$settings.preChargedDraft.ModificationAccepted === 'false') {
        this.modificationAccepted = false
      }
      if (this.$settings.preChargedDraft.draftName !== '') {
        this.draftName = this.$settings.preChargedDraft.draftName
      }
      if (typeof (this.$settings.preChargedDraft.multPmts) !== 'undefined' && this.$settings.preChargedDraft.multPmts !== '') {
        this.multPmts = this.$settings.preChargedDraft.multPmts
        for (i = 0; i < this.$settings.preChargedDraft.multPmts.length; i++) {
          this.multPmts[i] = this.$settings.preChargedDraft.multPmts[i]
        }
        this.payNumber = this.multPmts.length
      }
      this.idDraft = this.$settings.preChargedDraft.idDraft
      if (this.$settings.preChargedDraft.debtorName !== '') {
        this.debtorName = this.$settings.preChargedDraft.DebtorName
      }
      if (this.$settings.preChargedDraft.DebtorEmail !== '' && this.$settings.preChargedDraft.DebtorEmail != null) {
        this.debtorEmail = this.$settings.preChargedDraft.DebtorEmail
      }
      this.debtorBank = this.$settings.preChargedDraft.DebtorBankAccount
      if (this.debtorName !== '' && this.debtorEmail === '') {
        for (i = 0; i < this.contacts.length; i++) {
          if (this.contacts[i].name === this.$settings.preChargedDraft.DebtorName) {
            that.debtorName = this.contacts[i].name
            that.debtorBank = this.contacts[i].iban
            that.debtorEmail = this.contacts[i].identifier
          }
        }
      }
      for (i = 0; i < this.contacts.length; i++) {
        if (
          this.contacts[i].name === this.debtorName &&
          this.contacts[i].identifier === this.debtorEmail &&
          this.contacts[i].iban === this.debtorBank
        ) {
          this.selectedDebtor = this.contacts[i]
        }
      }
      for (let i = 0; i < this.bankAccounts.length; i++) {
        if (this.bankAccounts[i].iban === this.$settings.preChargedDraft.CreditorBankAccount) {
          this.creditorBankName = this.bankAccounts[i].name
        }
      }
    }
    this.$settings.preChargedDraft = undefined
    let contactsMap = this.contacts.map(function (obj) {
      let rObj = {}
      rObj[obj.label] = obj
      return rObj
    })
    let contactsMapObj = Object.assign({}, ...contactsMap)
    this.contactsPicker = this.$f7.picker({
      input: '#bookContacts',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(contactsMapObj)
        }
      ],
      onClose: function (p) {
        // var data = []
        that.debtorName = contactsMapObj[p.value].name
        that.debtorBank = contactsMapObj[p.value].iban
        that.debtorEmail = contactsMapObj[p.value].identifier
        that.contacts = contactsMapObj[p.value]
      }
    })
    let ibansMap = this.bankAccounts.map(function (obj) {
      let rObj = {}
      rObj[obj.name] = obj.iban
      return rObj
    })
    let ibansMapObj = Object.assign({}, ...ibansMap)
    this.accountsPicker = this.$f7.picker({
      input: '#account-input',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(ibansMapObj)
        }
      ],
      onClose: function (p) {
        that.creditorBank = ibansMapObj[p.value]
        that.creditorBankName = p.value
      },
      onOpen: function (p) {
        // that.creditorBankName = p.value
      }
    })
    /* let filesMap = this.cloudFiles.map(function (obj) {
      let rObj = {}
      rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
      return rObj
    })
    let filesMapObj = Object.assign({}, ...filesMap)
    let values = []
    if (Object.keys(filesMapObj).length > 0) {
      values = Object.keys(filesMapObj)
    } else {
      values = ['Nothing found']
    }
    this.cloudDocsPicker = this.$f7.picker({
      input: '#application-file-input',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: values
        }
      ],
      onClose: function (p) {
        if (Object.keys(filesMapObj).length > 0) {
          if (filesMapObj[p.value].id !== that.attachementId) {
            that.attachementId = filesMapObj[p.value].id
            that.cloudFileSel()
          }
        }
      },
      onOpen: function (p) {
        if (Object.keys(filesMapObj).length > 0) {
          that.attachmentName = p.value
        }
      }
    }) */
  },
  beforeDestroy () {
    this.attachmentName = ''
    this.attachment = ''
    this.debtorName = ''
    this.debtorBank = ''
    this.creditorBank = ''
    this.debtorEmail = ''
    this.remittanceInformation = ''
    this.depositExecutionDate = ''
    this.amount = ''
    this.attachementReference = ''
    this.modificationAccepted = false
    this.attachementId = ''
    this.loadingFile = ''
    this.fromCloud = ''
    this.bankAccounts = ''
    this.contacts = []
    this.cloudFiles = []
    this.ImmPmtAccepted = false
    this.cloudDocsPicker = ''
    this.accountsPicker = ''
    this.draftName = ''
    this.idDraft = ''

    let attachmentObj = {
      fromCloudList: false,
      id: 0,
      name: '',
      data: '',
      amount: 0,
      reference: '',
      debtorName: '',
      executionDate: ''
    }
    this.$engine.settings.set({preChargedFile: attachmentObj})
  },
  watch: {
    hasRegles: function (val) {
      // Si hasRegles devient false :
      if (!val) {
        // On charge les regles metier par defaut
        this.reglesMetier = this.$engine.reglesMetier.defaultData()
        // On réinitialise le sélecteur de règles métier
        const diffAmount = function (a, b) { return parseFloat(a.montant) - parseFloat(b.montant) }
        this.allRules = this.$R.sort(diffAmount, this.reglesMetier)
      }
    },
    loadingFile (val) {
      if (val) {
        this.$f7.showPreloader('Loading File')
      } else {
        this.$f7.hidePreloader()
      }
    },
    payNumber: function (val) {
      if (this.multPmts.length > 0) {
        if (this.hasRegles && this.reglesMetier.idReglesMetier) {
          if (val < this.reglesMetier.nbEcheances.min || val > this.reglesMetier.nbEcheances.max) {
            this.payNumber = this.reglesMetier.nbEcheances.min
          }
        } else {
          if (val < 1) {
            this.payNumber = 1
          }
        }
      }
    },
    'reglesMetier.idReglesMetier': function (val) {
      // Si des règles métier sont sélectionnées
      if (val !== undefined) {
        if (this.payNumber < this.reglesMetier.nbEcheances.min) {
          // Si le nombre d'échéances est < au nombre MIN autorisé --> payNumber = nb.MIN
          this.payNumber = this.reglesMetier.nbEcheances.min
        } else if (this.payNumber > this.reglesMetier.nbEcheances.max) {
          // Si le nombre d'échéances est > au nombre MAX autorisé --> payNumber = nb.MAX
          this.payNumber = this.reglesMetier.nbEcheances.max
        }
      }
    },
    selectedContact: function (val) {
      this.debtorName = val.name ? val.name : ''
      this.debtorEmail = val.identifier ? val.identifier : ''
      this.debtorBank = val.iban ? val.iban : ''
    }
  },
  methods: {
    accountPicker (e) {
      e.stopPropagation()
      this.accountsPicker.open()
    },
    addDebtor () {
      if (this.debtorName === '') {
        this.$f7.alert('', 'Debtor name invalid')
        return
      }
      if (this.debtorBank.length > 0) {
        if (validateIBAN(this.debtorBank) === null) {
          this.$f7.alert('', 'Debtor bank invalid')
          return
        }
      }
      if (this.debtorEmail === '') {
        this.$f7.alert('', 'Debtor email invalid')
        return
      }
      this.$engine.services.payments.debtorList.push({
        debtorName: this.debtorName,
        debtorBank: this.debtorBank,
        debtorEmail: this.debtorEmail
      })
      this.debtorName = ''
      this.debtorBank = ''
      this.debtorEmail = ''
    },
    calendar ($event) {
      /* eslint-disable no-undef */
      let that = this

      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.depositExecutionDate = dateResult
        })
      }
      /* eslint-enable no-undef */
    },
    calendar2 ($event, index) {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.multPmts[index].date = dateResult
          // that.Dom7($event.target).val(dateResult)
          that.Dom7($event.target).text(dateResult)
        })
      }
      /* eslint-enable no-undef */
    },
    changeSwitchModificationAccepted (obj) {
      this.modificationAccepted = obj.target.checked
    },
    clearAttachement () {
      this.refreshImport = !this.refreshImport
      this.attachement = ''
      this.attachmentName = ''
      this.attachmentReference = ''
      this.attachmentId = ''
      this.hasAttachment = false
    },
    cloudFileSel () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.attachmentId.toString())
        .then(response => {
          that.attachmentName = response.data.document_name
          that.attachement = response.data.document_data
          that.loadingFile = false
          that.attachmentReference = response.data.internal_reference
          that.Dom7('.fileNameDisplay').text(that.attachmentName)
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    // convertDateFormat () {
    //   this.executionDate = moment(this.executionDate).format('YYYY-MM-DD')
    // },
    createImage (file) {
      console.log('create image')
      var that = this
      var reader = new FileReader()
      reader.onload = (e) => {
        console.log('reader onload')
        that.attachement = reader.result
        if (that.isOcrActive === true) {
          console.log('ocr is active')
          if (this.fileIsFacturX) that.executeFacturX(that.attachement)
          else that.executeOCR('INVOICE', that.attachement)
        }
      }
      reader.readAsDataURL(file)
    },
    debtorPicker (e) {
      e.stopPropagation()
      if (this.loadingFile === true) { return }
      this.contactsPicker.open()
    },
    echeanceChanged ($event) {
      this.reglesMetier.nbEcheances = $event
      this.payNumber
      this.reglesMetier.nbEcheances.min
      this.reglesMetier.nbEcheances.max
      if ($event.min <= $event.max) {
        if (this.payNumber < $event.min || this.payNumber > $event.max) {
          this.payNumber = $event.min
        }
      } else {
        this.payNumber = 1
        this.hasInstallments = false
      }
    },
    executeFacturX (file) {
      const that = this

      // key : IHM reception parameter, value : OCR returned data
      const exchangeData = {
        recipientName: 'CreditorName',
        recipientBank: 'CreditorIban',
        recipientEmail: 'CreditorMail',
        executionDate: 'ExecutionDate',
        amount: 'AmountTTC',
        remittanceInformation: 'InvoiceReference',
        attachmentReference: 'InvoiceReference'
      }

      that.$f7.showPreloader(that.$i18n.t('sent.facturx_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')}))
      // Call API for OCR
      return that.$engine.services.facturx(file)
      .then(response => {
        // console.log('--- response', response)
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.facturx_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()

        // Extract data from response
        response = response.data
        // console.log('--- response.data', response)

        // Replace form values with OCR values
        for (var key in exchangeData) {
          var ExtractedValue = response[exchangeData[key]]
          if (ExtractedValue) {
            if (ExtractedValue === '$Error' || ExtractedValue === '$NotFound') {
              ExtractedValue = ''
            }
            // Formatting values from OCR to conform to accepted formats
            if (exchangeData[key] === 'Amount') ExtractedValue = ExtractedValue.replace(/,/g, '.') // `comma` -to-> `period`
            else if (exchangeData[key] === 'DebtorIban' || exchangeData[key] === 'CreditorIban') ExtractedValue = ExtractedValue.replace(/ /g, '') // Delete spaces

            that[key] = ExtractedValue
            if (key === 'beneficiaire') {
              let contacts = this.$engine.contacts.get()
              for (var kContact in contacts) {
                if (contacts[kContact].name === ExtractedValue) {
                  that.recipientEmail = contacts[kContact].identifier
                }
              }
            }
          }
        }
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.file_not_read') + ' ' + err)
        console.log(that.$i18n.t('errors.file_not_read') + ' ' + err)
      })
    },
    executeOCROnRIB (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 50000000) {
        let that = this
        var reader = new FileReader()
        reader.onload = (e) => {
          that.executeOCR('RIB', e.target.result)
        }
        return reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 50Mo', 'Maximum file size exceeded')
      }
    },
    /** @author ERI- TLV
    * @date 27/03/2020
    * @brief méthode qui execute l'OCR à partir de l'Order transmis en paramètre
    *     et qui affiche les données retournées sur l'IHM
    * @param filetype may be: RIB, Invoice, Order
    * @param file est l'image chiffrée en base64
    */
    executeOCR (filetype, file) {
      let that = this
      // key : IHM reception parameter, value : OCR returned data
      let exchangeData = {
        'RIB': {
          creditorBankAccount: 'iban',
          beneficiaire: 'name'
        },
        'Order': {
          debtorName: 'debtorName',
          beneficiaire: 'beneficiary',
          creditorBankAccount: 'creditorBankAccount',
          remittanceInformation: 'reason',
          debtorBank: 'debtorBankAccount',
          debtorEmail: 'creditorMail',
          amount: 'amount',
          executionDate: 'date',
          attachmentReference: 'reference'
        },
        'INVOICE': {
          amount: 'Amount',
          recipientBankAccount: 'CreditorIBAN',
          beneficiaire: 'CreditorName',
          recipientEmail: 'CreditorEmail',
          remittanceInformation: 'Reason',
          attachmentReference: 'Reference',
          debtorBankAccount: 'Iban',
          executionDate: 'DeliveryDate'
        }
      }
      that.$f7.showPreloader(that.$i18n.t('sent.ocr_loading'))
      return that.$engine.services.ocr(
        that.$engine.user.get().id,
        '',
        file,
        'jpeg',
        'scan',
        filetype
      ).then(response => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.ocr_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        response = response.data.ControlsInformations
        console.log('response', response)
        // Pour l'instant l'OCR ne marche qu'avec des IBAN
        this.recipientZoneCode = this.$engine.bankAccounts.getZoneData('EUR')
        const fileTypeData = exchangeData[filetype]
        for (var key in fileTypeData) {
          if (response[fileTypeData[key]]) {
            var ExtractedValue = response[fileTypeData[key]].Value
            // console.log(key, ' : ', ExtractedValue)
            if (ExtractedValue !== '$Error' &&
                ExtractedValue !== '$NotFound' &&
                ExtractedValue !== '') {
              that[key] = ExtractedValue
              if (key === 'beneficiaire') {
                let contacts = this.$engine.contacts.get()
                for (var kContact in contacts) {
                  if (contacts[kContact].name === ExtractedValue) {
                    that.recipientEmail = contacts[kContact].identifier
                  }
                }
              }
            }
          }
        }

        this.handleChangeRecipientZoneCode('EUR')

        /* TLV 03/2020 : Si l'IBAN expéditeur est reconnu par l'OCR, il n'est ajouté
          que s'il fait partie des comptes bancaires de l'utilisateur */
        if (response.Iban.Value) {
          let bankAccountsList = that.bankAccounts.filter(bank => bank.iban === response.Iban.Value)
          if (bankAccountsList.length > 0) {
            that.senderBank = bankAccountsList[0].iban
          }
        }
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
        console.log(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
      })
    },
    filesPicker (e) {
      e.stopPropagation()
      // if (this.loadingFile === true || !this.fromCloud) { return }
      this.cloudDocsPicker.open()
    },
    getAllInstallmentRules () {
      let that = this
      this.$engine.reglesMetier.get()
      .then(response => {
        const diffAmount = function (a, b) { return parseFloat(a.montant) - parseFloat(b.montant) }
        this.allRules = this.$R.sort(diffAmount, response.data.reglesMetier)
      }).catch(err => {
        errorMessageAlert(err, that)
      })
    },
    getNameDraft () {
      var namedraft = ''
      let that = this
      if (this.capsule === 'draft-create' || this.capsule === 'direct-debit-create') {
        this.$f7.modal({
          title: 'Please enter a name for your draft',
          // text: 'Enter a name of draft',
          afterText: '<div class="item-input"><input class="inputnamedraft" type="text"></div>',
          buttons: [
            {
              text: 'Cancel',
              color: 'red',
              onClick: function () {
              }
            },
            {
              text: 'Save',
              onClick: function () {
                let namedraft = that.Dom7('.inputnamedraft').val()
                that.draftName = namedraft
                that.SaveInDraft(namedraft)
              }
            }
          ]
        })
      } else {
        this.SaveInDraft(namedraft)
      }
    },
    handleChangeRecipientZoneCode (newCode) {
      const countries = this.countries.filter(country => country.label === newCode)
      if (countries.length > 0) {
        const country = countries[0]
        country.errors = {}
        this.recipientZoneCode = country

        /** TLV 19/03/2020
        * On extrait les donnees du faux IBAN en base en vraies donnees bancaires,
        * en fonction du pays, dans une variable locale appelee extractedBankData
        * qui permet d'afficher sur le formulaire les IBAN en fonction des pays
        */
        let extractedBankData = {}
        if (this.recipientZoneCode !== '' && this.recipientBankAccount !== '') {
          extractedBankData = extractForeignIban(this.recipientBankAccount, newCode)
        }
        let datavalues = {}
        for (var bankData in extractedBankData) {
          datavalues[extractedBankData[bankData].labelId] = extractedBankData[bankData].value
        }
        this.recipientZoneCode.values = datavalues
        this.contactSelected = true
      }
    },
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('card-header')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
          that.Dom7($event.target).find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).next().hide()
          that.Dom7($event.target).find('i').transform('rotate(0deg)')
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
          that.Dom7($event.target).parent().find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).parent().next().hide()
          that.Dom7($event.target).parent().find('i').transform('rotate(0deg)')
        }
      }
      // that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top - that.$$('.page-content').offset().top + that.$$('.page-content').scrollTop() + 300, 400)
      that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top + that.$$(that.$$('.page-content')[that.$$('.page-content').length - 1]).offset().top - 96, 400)
    },
    importRIB ($event) {
      this.Dom7(this.Dom7('.rib-file-input')[this.Dom7('.rib-file-input').length - 1]).click()
    },
    intervalleToSec (intervalle) {
      const jours = intervalle.jour === '' ? 0 : parseInt(intervalle.jour)
      const mois = intervalle.mois === '' ? 0 : parseInt(intervalle.mois)
      const annees = intervalle.annee === '' ? 0 : parseInt(intervalle.annee)
      return jours + mois * 30 + annees * 365
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 500000000) {
        this.createImage(files[0])
        this.attachmentName = files[0].name
        this.Dom7(this.Dom7('.fileNameDisplay')[this.Dom7('.fileNameDisplay').length - 1]).val(this.attachmentName)
      } else {
        this.$f7.alert(this.$i18n.t('creation_forms.file_size') + Math.round(files[0].size / 1000) + this.$i18n.t('creation_forms.max_file_size'))
      }
    },
    openCreateAttachmentInvoice () {
      loadPage(this, {url: '/attachments/createInvoice/'})
    },
    openDoc (attachmentId) {
      if (!this.attachement) {
        let that = this
        let win = window
        this.$f7.showPreloader(this.$t('common.getting_file'))
        this.$engine.services.payments.getAttachmentDetail(this.attachmentId)
          .then(response => {
            let blob = b64toBlob(response.data.documentData.split(',  ')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            const url = window.URL.createObjectURL(blob)
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$t('common.got_file'),
              buttons: [
                {
                  text: that.$t('common.open'),
                  onClick: function () {
                    win.open(url)
                  }
                }
              ]
            })
          })
          .catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
          })
      } else {
        let blob = b64toBlob(this.attachement.split(',')[1], this.attachement.split(';')[0].replace(/^data:/, ''))
        const url = window.URL.createObjectURL(blob)
        window.open(url)
      }
    },
    openImportAttachment (fileType) {
      if (fileType === '1') {
        let that = this
        that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
      }
      /* let that = this
      let buttons1
      if (this.hasCloudAttachments) {
        buttons1 = [
          {
            text: this.$t('common.import_device'),
            onClick: function () {
              that.attachement = ''
              that.attachmentName = ''
              that.attachmentId = ''
            }
          },
          {
            text: this.$t('creation_forms.imprt_frm_moneyroad'),
            onClick: function (event, event2) {
              that.attachement = ''
              that.attachmentName = ''
              that.attachmentId = ''
              that.filesPicker(event2)
            }
          },
          {
            text: this.$t('common.cncl'),
            color: 'red',
            onClick: function () {
            }
          }
        ]
      } else {
        buttons1 = [
          {
            text: this.$t('common.import_device'),
            onClick: function () {
              that.attachement = ''
              that.attachmentName = ''
              // that.attachmentReference = ''
              that.attachmentId = ''
              that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
            }
          },
          {
            text: this.$t('common.cncl'),
            color: 'red',
            onClick: function () {
            }
          }
        ]
      }
      this.$f7.actions(buttons1) */
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    paymentsDate () {
      if ((this.depositExecutionDate !== undefined) && (this.depositExecutionDate.length > 0)) {
        return this.depositExecutionDate
      } else {
        return 'Select a date'
      }
    },
    removeImage: function (e) {
      this.attachement = ''
    },
    SaveInDraft (namedraft) {
      let that = this
      this.depositExecutionDate = moment(this.depositExecutionDate).format('YYYY-MM-DD')
      this.multPmts.forEach(function (element) {
        element.date = moment(element.date).format('YYYY-MM-DD')
      })
      let draftArray = []

      if (that.capsule === 'draft-edit') {
        draftArray.push({
          'idDraft': that.idDraft,
          'idAccount': this.$engine.user.get().id,
          'DraftName': this.draftName,
          'CreditorName': this.$engine.user.get().name,
          'CreditorBankAccount': this.creditorBank,
          'CreditorIdentifier': this.$engine.user.get().identifier,
          'DebtorName': this.debtorName,
          'DebtorBankAccount': this.debtorBank,
          'DebtorIdentifier': this.debtorEmail,
          'StartingDate': this.depositExecutionDate,
          'FirstAmount': this.deposit,
          'CollectionAmount': this.amount,
          'Reason': this.remittanceInformation,
          'Currency': this.ccy,
          'attachmentName': that.attachmentName,
          'AttachmentReference': that.attachementReference,
          'Attachment': that.attachement,
          'multPmts': this.multPmts
        })
        this.$engine.ddDrafts.update(draftArray[0])
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/directDebit/draft/', force: false, ignoreCache: false})
            }, 2000)
          }
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
      } else { // capsule=='draft-create' or capsule=='direct-debit-create'
        let requestLoad = {
          'idAccount': this.$engine.user.get().id,
          'DraftName': this.draftName,
          'CreditorName': this.$engine.user.get().name,
          'CreditorBankAccount': this.creditorBank,
          'CreditorIdentifier': this.$engine.user.get().identifier,
          'DebtorName': this.debtorName,
          'DebtorBankAccount': this.debtorBank,
          'DebtorIdentifier': this.debtorEmail,
          'StartingDate': this.depositExecutionDate,
          'FirstAmount': this.deposit,
          'CollectionAmount': this.amount,
          'Reason': this.remittanceInformation,
          'Currency': this.ccy,
          'attachmentName': that.attachmentName,
          'AttachmentReference': that.attachementReference,
          'Attachment': that.attachement,
          'multPmts': this.multPmts
        }
        that.$engine.ddDrafts.create(requestLoad)
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            if (that.capsule === 'draft-create' || that.capsule === 'direct-debit-create') {
              setTimeout(function () {
                that.$f7.closeModal()
                loadPage(that, {url: '/directDebit/draft/', force: false, ignoreCache: false})
              }, 2000)
            } else {
              setTimeout(function () {
                that.$f7.closeModal()
                that.Dom7('.attachmentTaphold').removeClass('listItemSelected')
              }, 2000)
            }
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    scanOrder ($event) {
      /* eslint-disable no-undef */
      let that = this
      var options = {
        quality: 10,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }

      if (this.$engine.settings.directPayments.get().ocrActivation === '1') {
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()

              reader.onloadend = function (e) {
                executeOCR('Order', e.target.result.split(',')[1])
              }
              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      } else {
        console.log('OCR Non Actif')
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()
              reader.onloadend = function (e) {
                that.attachement = e.target.result
              }

              let ca = that
              that.$f7.modal({
                title: 'Please enter the name of the scan',
                // text: 'Enter a name of draft',
                afterText: '<div class="item-input"><input class="inputnamescan" type="text"></div>',
                buttons: [
                  {
                    text: 'Cancel',
                    color: 'red',
                    onClick: function () {
                    }
                  },
                  {
                    text: 'Done',
                    onClick: function () {
                      var lab = ca.Dom7('.inputnamescan').val()
                      ca.attachmentName = lab
                    }
                  }
                ]
              })
              that.attachmentReference = ''
              that.attachmentId = ''

              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      }
      /* eslint-enable no-undef */
    },
    sendDirectDebit: function () {
      let that = this

      let requestAlertText = this.$i18n.t('modularLoan.ml_sending')
      let responseAlertText = this.$i18n.t('modularLoan.ml_rqst_sent')

      this.sendPaymentsClicked = true
      let returnFlag = false
      let requestDetailsBlockFlag = false
      let debtorFlag = false
      let creidtorFlag = false
      let remittanceInformationFlag = false
      let depositExecutionDateFlag = false
      let amountFlag = false
      let depositDateFlag = false
      let depositFlag = false
      let multPmtFlag = false
      let invalidDateFlag = false // Si les dates d'un ML envoyé sont antérieures à aujourd'hui

      // Vérification sur le débiteur (nom, compte bancaire [IBAN], email)
      if (Object.keys(this.selectedDebtor).length === 0 && !this.debtorName && !this.debtorBank && !this.debtorEmail) {
        that.$$('.recipientBlock').show()
        returnFlag = true
        debtorFlag = true
      }

      //  Vérification sur le compte bancaire [IBAN] du créditeur
      if (this.creditorBank === '') {
        that.$$('.myAccountBlock').show()
        returnFlag = true
        creidtorFlag = true
      }

      // Vérification sur la raison
      if (this.remittanceInformation === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        remittanceInformationFlag = true
      }

      // Vérification sur la date d'exécution du dépôt
      if (this.depositExecutionDate === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        depositExecutionDateFlag = true
      }

      // Vérification sur le montant de la transaction
      if (!this.amount) {
        requestDetailsBlockFlag = true
        returnFlag = true
        amountFlag = true
      }

      let today = moment().format('YYYY-MM-DD')
      if (moment(this.depositExecutionDate).format('YYYY-MM-DD') < today) {
        requestDetailsBlockFlag = true
        returnFlag = true
        depositDateFlag = true
      }

      if (!this.deposit) {
        requestDetailsBlockFlag = true
        returnFlag = true
        depositFlag = true
      }

      if (this.hasInstallments) {
        for (let i = 0; i < this.multPmts.length; i++) {
          // TLV 14/10/2019 : si un montant d'installment vaut 0, c'est comme s'il était vide
          if (this.multPmts[i].date === '' || this.multPmts[i].amount === '' || this.multPmts[i].amount === 0 || this.multPmts[i].amount == null) {
            requestDetailsBlockFlag = true
            returnFlag = true
            multPmtFlag = true
          }
          if (moment(this.multPmts[i].date).format('YYYY-MM-DD') < moment(this.depositExecutionDate).format('YYYY-MM-DD')) {
            invalidDateFlag = true
            returnFlag = true
          }
        }
      } else if (!this.modificationInstallmentsAllowed) {
        requestDetailsBlockFlag = true
        returnFlag = true
        multPmtFlag = true
      }

      if (requestDetailsBlockFlag) {
        that.$$('.requestDetailsBlock').show()
      }

      // Vérification de non contradition entre delais entre deux echeances et delais total [regles metier]
      if (this.installmentRules) {
        const intervalleTotalSec = this.intervalleToSec(this.installmentRules.interval)
        const delaisTotalSec = this.intervalleToSec(this.installmentRules.totalPeriod)
        if (intervalleTotalSec > 0 && delaisTotalSec > 0 && intervalleTotalSec > delaisTotalSec) {
          this.$f7.alert('Time between installments should not be superior to time until last installment', 'Invalid')
          return
        }
      }

      if (debtorFlag) {
        this.$f7.alert('', 'Debtor missing')
      } else if (creidtorFlag) {
        this.$f7.alert('', 'Creditor missing')
      } else if (remittanceInformationFlag) {
        this.$f7.alert('', 'Reason missing')
      } else if (depositExecutionDateFlag) {
        this.$f7.alert('', 'Execution date missing')
      } else if (amountFlag) {
        this.$f7.alert('', 'Amount missing')
      } else if (depositDateFlag) {
        this.$f7.alert('Deposit date must be today or after', 'Deposit Date')
      } else if (depositFlag) {
        this.$f7.alert('', 'Deposit amount missing')
      } else if (multPmtFlag) {
        this.$f7.alert('', 'Installment missing')
      } else if (invalidDateFlag) {
        this.$f7.alert('', this.$t('errors.past_installment_date'))
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && !depositExecutionDateFlag && !amountFlag && !depositFlag && !multPmtFlag && !invalidDateFlag) {
      } else {
        this.$f7.alert('', 'Data missing')
      }

      if (returnFlag) {
        return
      }

      // TLV 14/10/2019 : Les dates d'installment doivent toutes être différentes. Sinon, le formulaire n'est pas envoyé
      if (this.hasInstallments) {
        let uniqueExecutionDate = []
        uniqueExecutionDate.push(this.depositExecutionDate)
        let flagUniqueExecutionDate = true
        for (let i = 0; i < this.multPmts.length; i++) {
          if (uniqueExecutionDate.includes(this.multPmts[i].date)) {
            flagUniqueExecutionDate = false
          } else {
            uniqueExecutionDate.push(this.multPmts[i].date)
          }
        }
        if (flagUniqueExecutionDate === false) {
          this.$f7.alert('Installment date should be all different', 'Invalid')
          return
        }
      }

      // Vérification que la somme des échéances et du dépôt ne soit pas supérieur au montant de la transaction
      if (this.sum > this.amount) {
        this.$f7.alert('Installments exceed total amount', 'Invalid Installments')
        return
      }

      const sortByDate = this.$R.sortBy(this.$R.prop('date'))
      const multPmtsSorted = sortByDate(this.multPmts)

      this.depositExecutionDate = moment(this.depositExecutionDate).format('YYYY-MM-DD')

      this.$f7.showPreloader(requestAlertText)

      that.$engine.services.directDebit
      .create({
        creditorIdentifier: this.$engine.user.get().identifier,
        creditorName: this.$engine.user.get().name,
        creditorBankAccount: that.creditorBank,
        debtorIdentifier: that.debtorEmail,
        debtorName: that.debtorName,
        debtorBankAccount: that.debtorBank,
        reason: that.remittanceInformation,
        deposit: that.deposit,
        depositExecutionDate: that.depositExecutionDate,
        amount: that.amount,
        currency: 'EUR',
        multiExecutions: multPmtsSorted,
        attachmentName: that.attachmentName,
        attachmentReference: that.attachementReference,
        attachmentData: that.attachement,
        hasInstallmentRules: (that.hasRegles ? '1' : '0'),
        hasInstallments: (that.hasInstallments ? '1' : '0'),
        initiator: 'creditor',
        reglesMetier: that.reglesMetier,
        negotiation_allowed: (that.negotiationAllowed ? '1' : '0'),
        modification_installments_allowed: (that.modificationInstallmentsAllowed ? '1' : '0')
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          if (that.capsule === 'draft-edit') {
            that.$engine.ddDrafts.del(that.idDraft)
            .then(response => {
              that.$f7.hidePreloader()
              this.$f7.modal({
                title: responseAlertText,
                text: '<i class="icon fa fa-check"></i>'
              })
              this.$engine.services.directDebit.debtorList = []
              this.$engine.services.directDebit.contactDebtorList = []
              setTimeout(function () {
                that.$f7.closeModal()
                loadPage(that, {url: '/inbox/1'})
              }, 2000)
            })
          } else {
            that.$f7.hidePreloader()
            this.$f7.modal({
              title: responseAlertText,
              text: '<i class="icon fa fa-check"></i>'
            })
            this.$engine.services.directDebit.debtorList = []
            this.$engine.services.directDebit.contactDebtorList = []
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/inbox/1'})
            }, 2000)
          }
        }
      })
      .catch(err => {
        let message = this.getTextError(err) // mixins errorHandlerMixins
        if (message !== '') {
          that.$f7.alert(message, this.$t('regles_metier.errors'))
        }
      }).finally(() => {
        that.$f7.hidePreloader()
      })
    },
    setContacts: function () {
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, identifier: this.$engine.contacts.get(j).identifier, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id})
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = this.orderKeys(contactList)
    },
    setInstallmentRules (event) {
      let id = event.target.value
      if (id) {
        if (id > 0) {
          this.reglesMetier = this.$R.clone(this.allRules.filter(rule => rule.idReglesMetier === id)[0])
        } else {
          let rule = this.$engine.reglesMetier.defaultData()
          rule.idReglesMetier = id
          this.reglesMetier = rule
        }
      } else {
        this.reglesMetier.idReglesMetier = undefined
      }
    },
    switched () {
      this.fromCloud = !this.fromCloud
      this.attachmentName = ''
      this.attachement = ''
      this.attachementId = ''
    },
    view (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      const that = this
      this.$f7.showPreloader(this.$t('common.dwnldng_fl'))
      if (id) {
        this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', that.$t('errors.err_crtng_fl'))
              }
            )
          } else {
            let blob = b64toBlob(response.data.documentData.split(',')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            fileLink.setAttribute('download', response.data.documentName) // or any other extension
            fileLink.click()
          }
          setTimeout(function () { that.$f7.hidePreloader() }, 1000)
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
      } else {
        let blob = b64toBlob(this.attachement.split(',')[1], this.attachement.split(';')[0].replace(/^data:/, ''))
        const url = window.URL.createObjectURL(blob)
        const fileLink = document.createElement('a')
        fileLink.href = url
        fileLink.setAttribute('download', this.attachementNameLabel) // or any other extension
        fileLink.click()
        this.$f7.hidePreloader()
      }
    }
  }
}
</script>
<style>
.button-setting {
  width: 80px;
}
#cloud-label {
  color: #12bcf1;
  width: 30%;
  background-color: #e6e7e8;
  padding: 3px 3px 3px 3px;
  text-align: center;
  display: inline-block;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #12bcf1;
}
.Column50 {
  width: 50% !important;
}
.custom-item-inner {
  width: 100%;
  padding: 8px 15px 7px 0px;
}
.facturePart2 {
  color: black;
}
.formTitle {
  color:white !important;
  text-align: center;
  margin: auto;
}
.grayEmpty{
  background-color: #f7f7f7;
}

.negotiateSwitch {
  width: auto !important;
  margin-right: 30px;
}
.paymentsButtonLength {
  width: 113px;
}
.paymentsRequestAddOtherDebtor {
  margin-left: 7px !important;
  float: right !important;
  position: relative !important;
  color: #777777;
}
.paymentsRequestSubOption {
  font-size: 14px;
}
.paymentsRequestSubOption input::-webkit-input-placeholder {
  font-size: 14px;
}
.subtitleDebtorList {
  color: #000000;
}
.test-after{
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  display: block;
  white-space: nowrap;
  color: #8e8e93;
  flex-shrink: 0;
  margin-left: auto;
  padding-left: 5px;
  max-height: 28px;
}
.test-content{
  border-style: solid;
  border-width: 1px;
  border-color: #EBEBED;

	min-height: 15px;

	box-sizing: border-box;
  padding-left: 15px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
}
.test-inner{
  min-height: 15px;
  padding-right: 15px;
  position: relative;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 7px;

  box-sizing: border-box;
  display: flex;
  -webkit-box-flex: 1;

  overflow: hidden;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  align-self: stretch;
}
.test-title{
  color: #0E0144;
  flex-shrink: 1;
  min-width: 0;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
